import config from "../config/server-config";
import { apiClient } from "../api";
import { API_CALL_SUCCESS } from "../constant/NumberConstant";

export const getHomeData = async () => {
  try {
    const response = await apiClient.get(config.homePageData, {
      params: { page: "home" },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const getExperiencesData = async () => {
  try {
    const response = await apiClient.get(config.experiencesPageData, {
      params: { page: "experiences" },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const getAboutData = async () => {
  try {
    const response = await apiClient.get(config.aboutPageData, {
      params: { page: "about" },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const getServicesData = async () => {
  try {
    const response = await apiClient.get(config.servicesPageData, {
      params: { page: "service" },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const createInquiry = async (req) => {
  try {
    const response = await apiClient.post(config.createInquiry, req);
    return response.data;
  } catch (error) {
    return false;
  }
};